export function temperatureColor(
  temperature: number,
  saturation: number = 1,
): string {
  // Default configuration: [degree, hue] pairs
  const defaultConfig: [number, number][] = [
    [-10, 240], // Blue for cold (clearly visible below 15°C)
    [15, 180], // Cyan at 15°C (transition point)
    [20, 120], // Green starts at 20°C
    [30, 120], // Green ends at 30°C
    [35, 60], // Yellow at 35°C (transition point)
    [60, 0], // Red for hot (clearly visible above 35°C)
  ];

  return temperatureColorWithConfig(temperature, defaultConfig, saturation);
}

export function temperatureColorWithConfig(
  temperature: number,
  config: [number, number][], // [degree, hue] pairs
  saturation: number = 1,
): string {
  if (config.length < 2) {
    throw new Error('Config must have at least 2 points');
  }

  // Sort config by temperature to ensure proper order
  const sortedConfig = [...config].sort((a, b) => a[0] - b[0]);
  const minTemp = sortedConfig[0][0];
  const maxTemp = sortedConfig[sortedConfig.length - 1][0];

  // Clamp temperature to the range
  const clamped = Math.max(minTemp, Math.min(maxTemp, temperature));

  // Find the appropriate segment
  let hue: number = sortedConfig[0][1]; // Default to first hue

  if (clamped <= sortedConfig[0][0]) {
    // At or below minimum temperature
    hue = sortedConfig[0][1];
  } else if (clamped >= sortedConfig[sortedConfig.length - 1][0]) {
    // At or above maximum temperature
    hue = sortedConfig[sortedConfig.length - 1][1];
  } else {
    // Find the segment where temperature falls
    for (let i = 0; i < sortedConfig.length - 1; i++) {
      const [temp1, hue1] = sortedConfig[i];
      const [temp2, hue2] = sortedConfig[i + 1];

      if (clamped >= temp1 && clamped <= temp2) {
        // Interpolate between the two points
        const ratio = (clamped - temp1) / (temp2 - temp1);
        hue = hue1 + (hue2 - hue1) * ratio;
        break;
      }
    }
  }

  return `hsl(${Math.abs(hue).toFixed(0)}, ${saturation * 100}%, 50%)`;
}
